// notificationUtils.js - Sistema de notificaciones

export const mostrarNotificacion = (mensaje, tipo = 'info') => {
  const container = document.getElementById('notification-container');
  
  if (!container) {
    console.warn('Contenedor de notificaciones no encontrado');
    return;
  }

  // Crear elemento de notificación
  const notificacion = document.createElement('div');
  const id = `notif-${Date.now()}`;
  notificacion.id = id;

  // Colores según tipo
  const colores = {
    'éxito': 'bg-green-500 border-green-600',
    'error': 'bg-red-500 border-red-600',
    'info': 'bg-blue-500 border-blue-600',
    'advertencia': 'bg-yellow-500 border-yellow-600'
  };

  const iconos = {
    'éxito': '✅',
    'error': '❌',
    'info': 'ℹ️',
    'advertencia': '⚠️'
  };

  notificacion.className = `
    ${colores[tipo] || colores['info']}
    text-white px-6 py-4 rounded-lg shadow-lg
    border-2 animate-slide-in
    flex items-center gap-3
    min-w-[300px] max-w-[400px]
  `;

  notificacion.innerHTML = `
    <span class="text-xl">${iconos[tipo] || '📢'}</span>
    <span class="flex-1">${mensaje}</span>
    <button class="ml-2 opacity-70 hover:opacity-100 transition">
      ✕
    </button>
  `;

  // Agregar evento al botón de cerrar
  notificacion.querySelector('button').addEventListener('click', () => {
    notificacion.remove();
  });

  // Agregar a contenedor
  container.appendChild(notificacion);

  // Auto-remover después de 4 segundos
  setTimeout(() => {
    if (notificacion.parentNode) {
      notificacion.remove();
    }
  }, 4000);
};

// Estilos CSS para las notificaciones
export const agregarEstilosNotificaciones = () => {
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes slideIn {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }

    @keyframes slideOut {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }

    .animate-slide-in {
      animation: slideIn 0.3s ease-out;
    }

    #notification-container {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  `;
  document.head.appendChild(style);
};

// Confirmación con notificación
export const mostrarConfirmacion = (mensaje) => {
  return new Promise((resolve) => {
    mostrarNotificacion(mensaje, 'info');
    // En el futuro se puede implementar un modal de confirmación
    resolve(true);
  });
};

// Notificación de error con detalles
export const mostrarError = (mensaje, detalles = '') => {
  let mensajeCompleto = mensaje;
  if (detalles) {
    mensajeCompleto += ` - ${detalles}`;
  }
  mostrarNotificacion(mensajeCompleto, 'error');
  console.error(mensaje, detalles);
};

// Notificación de éxito
export const mostrarExito = (mensaje) => {
  mostrarNotificacion(mensaje, 'éxito');
};

// Notificación de advertencia
export const mostrarAdvertencia = (mensaje) => {
  mostrarNotificacion(mensaje, 'advertencia');
};

// Notificación de información
export const mostrarInfo = (mensaje) => {
  mostrarNotificacion(mensaje, 'info');
};

// Notificación con acciones
export const mostrarNotificacionConAccion = (mensaje, accionTexto, accionCallback, tipo = 'info') => {
  const container = document.getElementById('notification-container');
  
  if (!container) return;

  const notificacion = document.createElement('div');
  const id = `notif-${Date.now()}`;
  notificacion.id = id;

  const colores = {
    'éxito': 'bg-green-500',
    'error': 'bg-red-500',
    'info': 'bg-blue-500',
    'advertencia': 'bg-yellow-500'
  };

  notificacion.className = `
    ${colores[tipo] || colores['info']}
    text-white px-6 py-4 rounded-lg shadow-lg
    flex items-center justify-between gap-3
    min-w-[400px]
    animate-slide-in
  `;

  notificacion.innerHTML = `
    <span>${mensaje}</span>
    <div class="flex gap-2">
      <button class="action-btn px-4 py-2 bg-white bg-opacity-20 hover:bg-opacity-30 rounded transition">
        ${accionTexto}
      </button>
      <button class="close-btn opacity-70 hover:opacity-100 transition">
        ✕
      </button>
    </div>
  `;

  // Event listeners
  notificacion.querySelector('.action-btn').addEventListener('click', () => {
    accionCallback();
    notificacion.remove();
  });

  notificacion.querySelector('.close-btn').addEventListener('click', () => {
    notificacion.remove();
  });

  container.appendChild(notificacion);

  // Auto-remover
  setTimeout(() => {
    if (notificacion.parentNode) {
      notificacion.remove();
    }
  }, 6000);
};

// Obtener cantidad de notificaciones activas
export const obtenerNotificacionesActivas = () => {
  const container = document.getElementById('notification-container');
  return container ? container.children.length : 0;
};

// Limpiar todas las notificaciones
export const limpiarNotificaciones = () => {
  const container = document.getElementById('notification-container');
  if (container) {
    container.innerHTML = '';
  }
};
